import { useDispatch, useSelector } from "react-redux";
import { getMiljokontrollKommentarer as getMiljokontrollKommentarerAction } from "../../../../actions/miljokontrollerActions";
import MiljokontrollKommentarer from "../../../Miljogebyr/Detalj/MiljokontrollKommentarer";

export default function MiljokontrollKommentarerContainer(ownProps) {
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const miljokontrollKommentarer = useSelector(
    (state) => state.miljokontrollKommentarer
  );
  const dispatch = useDispatch();

  const getMiljokontrollKommentarer = (miljokontrollId) =>
    dispatch(getMiljokontrollKommentarerAction(miljokontrollId));

  return (
    <MiljokontrollKommentarer
      miljogebyr={miljogebyr}
      miljokontrollKommentarer={miljokontrollKommentarer}
      getMiljokontrollKommentarer={getMiljokontrollKommentarer}
      {...ownProps}
    />
  );
}
